<template>
    <v-container>
        <h3 class="primary--text">Reporte de vacunas</h3>
        <v-spacer></v-spacer>
        <v-layout>
            <v-flex>
                <div>
                    <v-layout>
                        <v-flex xs12 sm6>
                            <v-select v-model="company"
                                        :items="$store.state.companies"
                                        item-value="id"
                                        item-text="name"
                                        :rules="[v => !!v || 'Cliente es requerido']"
                                        label="Cliente"
                                        return-object
                                        persistent-hint
                                        required
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <download-excel :fetch="getVaccineReport"
                        style="width:200px"
                        name="reporte_vacunas.xls">
            <v-btn small color="primary">
                Reporte de vacunas
                <v-icon right dark>cloud_download</v-icon>
            </v-btn>
        </download-excel>
    </v-container>
</template>
<script>
    const pause = ms => new Promise(resolve => setTimeout(resolve, ms));    
    export default {
        data() {
            return {
                company: ''
            }
        },
        methods: {
            async getVaccineReport() {
                if (!this.company) {
                    alert("Debe elegir un cliente.");
                    return;
                }
                this.$store.state.progress = true;
                var reportList = [];                
                await this.$store.dispatch('getPatientVaccineByCompanyId', this.company.id).then(
                    response => {                        
                        for (let i = 0; i < response.data.length; i++) {                                                            
                            var reportAux = new Object();
                            reportAux.NOMBRE_PACIENTE = response.data[i].patientRouteSheet.patient.firstLastName + " " +
                                                        response.data[i].patientRouteSheet.patient.secondLastName + " " +
                                                        response.data[i].patientRouteSheet.patient.firstName + " " +
                                                        response.data[i].patientRouteSheet.patient.secondName;
                            reportAux.VACUNA = response.data[i].vaccine.name;
                            reportAux.FECHA = response.data[i].dateVaccine;                            
                            reportAux.LOTE = response.data[i].lote;
                            reportAux.OBSERVACION = response.data[i].observacion;
                            reportAux.RESPONSABLE = response.data[i].responsable;                                                                                                  
                            reportList.push(reportAux);
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
                if (reportList.length == 0) {
                    alert('No existen registros.');
                }
                this.$store.state.progress = false;
                return reportList;
            }
        },
        created() {
            this.$store.dispatch('getCompanies').then(response => {
            }, error => {
                this.$store.state.dialogError = true
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/reports/VaccinesReport.vue